import React, { useState, useEffect } from 'react';
import './UserSearchResultModal.css';

/**
 * 사용자 검색 결과 다건 선택 모달
 * @param {boolean} isOpen - 모달 열림 여부
 * @param {Array} users - 검색된 사용자 배열 [{ target_id, disp_target_name, name, position, dept_name }]
 * @param {Function} onConfirm - 확인 클릭 시 선택된 사용자 목록 전달 (selectedUsers: Array)
 * @param {Function} onClose - 취소/닫기 콜백
 */
const UserSearchResultModal = ({ isOpen, users = [], disabledUserIds = [], onConfirm, onClose }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setItems(users.map(u => ({
        ...u,
        checked: false,
        disabled: disabledUserIds.some(d => String(d) === String(u.target_id) || String(d) === String(u.userid) || String(d) === String(u.id))
      })));
    }
  }, [isOpen, users, disabledUserIds]);

  if (!isOpen) return null;

  const toggleCheck = (idx) => {
    setItems(prev => prev.map((item, i) => {
      if (i === idx) {
        if (item.disabled) return item;
        return { ...item, checked: !item.checked };
      }
      return item;
    }));
  };

  const handleConfirm = () => {
    const selected = items.filter(item => item.checked && !item.disabled);
    if (selected.length === 0) {
      alert('추가할 사용자를 1명 이상 선택해 주세요.');
      return;
    }
    onConfirm(selected);
  };

  return (
    <div className="user-search-backdrop" onClick={onClose}>
      <div className="user-search-modal-container" onClick={e => e.stopPropagation()}>
        <div className="user-search-modal-header">검색결과</div>
        <div className="user-search-modal-body">
          <ul className="user-search-modal-list">
            {items.map((user, idx) => (
              <li
                key={user.target_id || idx}
                onClick={() => toggleCheck(idx)}
                style={{
                  cursor: user.disabled ? 'not-allowed' : 'pointer',
                  opacity: user.disabled ? 0.45 : 1,
                  backgroundColor: user.disabled ? '#f8f9fa' : undefined
                }}
                title={user.disabled ? '선택할 수 없는 사용자입니다 (본인 또는 이미 등록됨)' : undefined}
              >
                <input
                  type="checkbox"
                  checked={user.checked || false}
                  disabled={user.disabled}
                  onChange={() => toggleCheck(idx)}
                  onClick={e => e.stopPropagation()}
                />
                <div style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 1 }}>
                  <span>{user.disp_target_name}</span>
                  {user.disabled && (
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '16px',
                        padding: '0 5px',
                        fontSize: '9px',
                        fontWeight: '600',
                        borderRadius: '3px',
                        backgroundColor: '#fee2e2',
                        color: '#dc2626',
                        border: '1px solid #fca5a5',
                        letterSpacing: '-0.3px',
                        boxSizing: 'border-box',
                        marginLeft: '6px',
                        lineHeight: 1
                      }}
                    >
                      선택불가
                    </span>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="user-search-modal-buttons">
          <button type="button" className="user-search-btn-confirm" onClick={handleConfirm}>
            확인
          </button>
          <button type="button" className="user-search-btn-cancel" onClick={onClose}>
            취소
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserSearchResultModal;
